import printAxios from "../../api/printAxios"
import { IDisciplineCronogramaPrint, IExercisesPrint, IWeekCronogramaPrint } from "../../models/Print";

const STORAGE_BASE_URL = "https://storage.aprovatotal.com.br";

const replaceStorage = (html: string | undefined | null): string => {
  if (!html) return "";
  return html.replaceAll("{STORAGE_BASE_URL}", STORAGE_BASE_URL);
};

export const printCronogramaWeek = async (body: IWeekCronogramaPrint) => {
  try {
    const { data } = await printAxios.post('/pdf', body, {
      responseType: 'blob',
      headers: {
        Accept: 'application/pdf',
      },
    })

    return data;
  } catch (e: any) {
    throw new Error(e)
  }
}

export const printCronogramaDiscipline = async (body: IDisciplineCronogramaPrint) => {
  try {
    const { data } = await printAxios.post('/pdf-discipline', body, {
      responseType: 'blob',
      headers: {
        Accept: 'application/pdf',
      },
    })

    return data;
  } catch (e: any) {
    throw new Error(e)
  }
}

export const printExercises = async (body: IExercisesPrint) => {
  try {
    const payload: IExercisesPrint = {
      ...body,
      exercises: body.exercises.map((ex) => ({
        _id: ex._id,
        slug: ex.slug,
        title: ex.title,
        statement: replaceStorage(ex.statement),
        resolution: ex.resolution ? replaceStorage(ex.resolution) : undefined,
        alternatives: (ex.alternatives ?? []).map((alt) => ({
          text: replaceStorage(alt.text),
          correct: !!alt.correct,
        })),
      })),
    }

    const { data } = await printAxios.post('/pdf-exercises', payload, {
      responseType: 'blob',
      headers: {
        Accept: 'application/pdf',
      },
    })

    return data;
  } catch (e: any) {
    throw new Error(e)
  }
}